module.exports = "<p class=\"title\">{{'quickTip.title' | translate}}</p>\r\n<p class=\"sub-title\">{{'quickTip.subTitle' | translate}}</p>\r\n\r\n<div class=\"numbers\">\r\n    <div class=\"number\"\r\n         (click)=\"quickTippSelected.emit(n)\"\r\n         *ngFor=\"let n of [1, 2, 3, 4, 5, 6, 7 ,8]\">{{n}}\r\n    </div>\r\n</div>\r\n\r\n<div class=\"cancel\"\r\n     (click)=\"quickTippSelected.emit(0)\">{{'quickTip.cancel' | translate}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/quick-tipp/quick-tipp.component.html
// module id = ../../../../../src/app/betting/quick-tipp/quick-tipp.component.html
// module chunks = 1